import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

/**
 * A soft grey tile with a small label above its value.
 *
 * Distinct from `StatCard`, which is the taller value-first KPI tile on the
 * waste dashboards: this one is compact enough to sit five across inside a
 * section card, and takes a text value as readily as a number. It backs both
 * the facility-information fields and the on-site stat row on the accumulation
 * areas page, which is why the label/value pair is one component rather than
 * two near-identical ones.
 */
export function FieldBox({
  label,
  value,
  valueColor = "text.primary",
  emphasis = "text",
}: {
  label: string;
  value: ReactNode;
  valueColor?: string;
  /** `"figure"` sizes the value as a headline number rather than body text. */
  emphasis?: "text" | "figure";
}) {
  return (
    <Box
      sx={{
        px: 1.75,
        py: 1.25,
        minWidth: 0,
        backgroundColor: (theme) => theme.palette.grey50.main,
        borderRadius: 1.5,
      }}
    >
      <Typography component="div" variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography
        component="div"
        variant={emphasis === "figure" ? "h6" : "body1"}
        color={valueColor}
        sx={{ mt: 0.25 }}
      >
        {value}
      </Typography>
    </Box>
  );
}
